import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// import WechatPlugin from './libs/WechatPlugin'
// 全局注册微信jsdk

import {
  Field,
  List,
  Dialog,
  Toast,
  Button,
  Notify,
  Grid,
  GridItem,
  Image as VanImage,
  Lazyload,
  NumberKeyboard,
  Cell,
  CellGroup,
  Uploader,
  RadioGroup,
  Radio,
  Popup,
  Overlay,
  Icon,
  CountDown
} from 'vant';
/* eslint-disable */
if (process.env.NODE_ENV !== 'production') require('@/mock')

Vue.use(CountDown);
Vue.use(Icon)
Vue.use(Overlay)
Vue.use(Popup)
Vue.use(NumberKeyboard);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Uploader);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(VanImage);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Button);
Vue.use(Notify);
Vue.use(List);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Lazyload )
// Vue.use(WechatPlugin) // 微信sdk
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
